<template>
  <div v-if="selectedItem" class="side--modal">
    <h6 class="primaryBg whiteText rounded p-2 mb-2">
      Select Parts
    </h6>
    
    <div class="modalSearch">
      <div class="form-group">
        <input
          v-model="search"
          type="text"
          class="form-control"
          placeholder="Search Part"
          @input="onSearch" 
        >
        <button class="p-0 border-0">
          <img
            src="../../assets/images/search-white.png"
            alt=""
          >
        </button>
      </div>
    </div>
    <div class="listCheckbox mt-2 mb-3">
      <ul class="list-inline mb-0">
        <li
          v-for="(item, idx) in filteredList"
          :key="idx"
        >
          <div class="checkbox-container">
            <input
              :id="item.part_id + '-' + index"
              type="checkbox"
              :checked="isChecked(item)"
              @change="toggleSelection(item)"
            >
            <label
              class="checkbox"
              :for="item.part_id + '-' + index"
            >{{ item.part_name }}</label>
          </div>
        </li>
      </ul>
    </div>
    
    <v-pagination v-if="total_pages > 1" v-model="page" :pages="total_pages" :range-size="1" active-color="#fe5000" />
  </div>
</template>

<script>

import { mapActions, mapGetters } from "vuex";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {
  props: ["item", "index"],

  data() {
    return {
      pageLimit: 100,
      search: "",
      page: 1,
      selectedItem: null,
      jobId: this.$route.params.id,
      total_pages: 0,
      partsList: [],
      debounceTimer: null,
      isLoading: true,
    };
  },

  components: {
    VPagination,
  },

  computed: {
    ...mapGetters([
      "bookingResponse",
      "bookingParts",
    ]),

    pages() {
      return this.total_pages
    },

    filteredList() {
      return this.partsList
    },
  },

  watch: {

    bookingParts: {
      handler: function (value, newValue) {
        this.isLoading = false
        clearTimeout(this.debounceTimer);
        this.setScroll()
        this.partsList = this.bookingParts.body
        this.total_pages = this.bookingParts.paging.total_pages
      }
    },

    page: {
      handler: function (value, newValue) {
        this.getPartsCall()
      }
    },

    item: function () {

      this.page = 1
      this.total_pages = 0
      this.partsList = []
      this.search = ""
      this.selectedItem = this.item;
      this.getPartsCall()
    },

  },

  mounted() {
    this.search = ""
  },

  methods: {
    ...mapActions([
      "getBookingParts",
    ]),

    onSearch() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer
      this.page = 1
      this.debounceTimer = setTimeout(() => {
        if (this.search.length == 0 || this.search.trim().length > 0) {
          this.getPartsCall()
        }
      }, 1000); // 1000ms delay
    },

    isChecked(item) {
      return this.selectedItem.parts.some(part => part.part_id === item.part_id);
    },

    toggleSelection(item) {

      if (this.bookingResponse.is_flat_price_model) {
        this.selectedItem.parts = []
        this.selectedItem.parts.push(JSON.parse(JSON.stringify(item))); // Add item

      } else {
        const index = this.selectedItem.parts.findIndex(part => part.part_id === item.part_id);
        if (index > -1) {
          this.selectedItem.parts.splice(index, 1); // Remove item
        } else {
          this.selectedItem.parts.push(JSON.parse(JSON.stringify(item))); // Add item
        }
      }

    },

    setScroll() {
      const ulElement = document.querySelector('.listCheckbox ul');
      if (ulElement) {
        ulElement.scrollTop = 0; // Scrolls to the top
      }
    },

    getPartsCall() {
      this.isLoading = true
      this.getBookingParts({
        "page": this.page,
        "limit": this.pageLimit,
        "search": this.search,
        category_id: "0",
        booking_id: this.jobId,
      });
    },

    clearSearchClicked() {
      this.search = ""
      this.page = 1
      this.getPartsCall()
    },


  },
};
</script>


<style>
.side--modal .Pagination {
  justify-content: center;
  margin: 1rem 0 20px 0;
}

.selectPartSidebar .PaginationControl,
.selectPartSidebar .Page {
  border: 1px solid #ccc;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 1px !important;
  line-height: 0;
}

.selectPartSidebar .Page-active {
  width: 30px;
  height: 30px;
  border: 1px solid #fe5000;
  color: #fff;
}
.buttonsList{
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  padding: 0.5rem;
  line-height: 1;
}
.buttonsList span {
    width: 18px;
    height: 18px;
    text-align: center;
    color: #fff;
}
@media (max-width: 1200px) {
  .selectPartSidebar .Pagination {
    justify-content: center;
    margin: 1rem 0;
  }
}
</style>
